import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinpune() {



  const cardData =
  {
    keyword: 'Urbania On Rent in Pune',
    heading: 'Amruta Travels: Urbania On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Urbania on Rent in Pune for travelers seeking a luxurious, spacious, and comfortable travel experience. Our premium Urbania vans are perfect for corporate trips, airport transfers, weddings, and family tours, ensuring a smooth and stylish journey across Pune, Mumbai, Nashik, and nearby destinations. With professional chauffeurs, on-time service, and features like plush seating, air conditioning, and ample luggage space, Amruta Travels guarantees a first-class experience for every occasion. Whether you need a 10-seater, 13-seater, or 17-seater Urbania on rent in Pune, we provide reliable, well-maintained vehicles tailored to your comfort and travel needs.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Once the royal residence of Bajirao I, it reflects the grandeur of Maratha architecture with its massive gates, fountains, and gardens. The evening light and sound show brings history to life. Shaniwar Wada remains a must-visit heritage site that tells the glorious tale of Pune’s royal past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a symbol of India’s freedom struggle and a masterpiece of Indo-Islamic architecture. Built in 1892 by Sultan Muhammed Shah Aga Khan III, it served as a prison for Mahatma Gandhi and his wife Kasturba during the Quit India Movement. The museum inside preserves rare photos and personal belongings of Gandhi. It stands today as Pune’s monument of peace and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, perched atop the Sahyadri hills, is a historical fortress famous for the valor of Tanaji Malusare. The fort offers breathtaking panoramic views of the surrounding valleys and is a popular trekking destination. Ancient ruins, cannons, and the Tanaji memorial make it a must-see for history lovers. Sinhagad Fort is Pune’s majestic reminder of Maratha bravery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s spiritual heart, attracting devotees from across India. The temple’s beautifully adorned idol of Lord Ganesha is known for its grandeur and divine presence. During Ganesh Chaturthi, the area transforms into a dazzling festival of lights, music, and devotion. It’s a sacred landmark representing Pune’s deep-rooted faith and cultural pride."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is a serene escape in Pune offering panoramic city views and spiritual calm. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. The 108-step climb rewards visitors with peace and stunning sunsets. Parvati Hill combines Pune’s heritage, spirituality, and scenic beauty in one tranquil experience."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple carved from basalt stone, dedicated to Lord Shiva. The temple’s circular Nandi mandapa and stone pillars showcase ancient Indian craftsmanship. Located in the city center, it offers a quiet retreat from urban hustle. Pataleshwar Temple stands as Pune’s timeless link to its ancient spiritual roots."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts showcasing India’s rich cultural heritage. From antique musical instruments to intricate carvings and rare household items, it’s a treasure trove of history. Founded by Dr. D.G. Kelkar, the museum celebrates India’s artistic excellence. It’s one of Pune’s most fascinating destinations for culture enthusiasts."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, Osho Ashram is a global meditation center attracting visitors seeking peace and transformation. Surrounded by lush greenery and tranquil gardens, it offers meditation sessions, yoga, and wellness therapies. The ashram’s modern design and spiritual vibe create a unique experience. Osho Ashram is Pune’s international hub for inner healing and mindfulness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular weekend getaway just outside Pune, offering serene lakeside views and breezy weather. It supplies water to the city and provides a scenic backdrop for picnics and evening drives. Visitors enjoy street food stalls and photography near the lake. Khadakwasla is Pune’s peaceful escape into nature."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s Korakuen Garden, is a beautifully landscaped park in Sinhagad Road. With its flowing streams, manicured lawns, and traditional Japanese design, it offers a tranquil environment for nature lovers. Families and couples stroll along its bridges and pathways. It symbolizes Pune’s connection to global harmony and natural beauty."
  }
],



"services": [
    {
      "name": "Urbania On Rent in Pune",
      "description": "Urbania On Rent in Pune offers comfortable and spacious van rentals, perfect for family trips, corporate outings, and group travel. With well-maintained vehicles and professional drivers, it ensures a safe and pleasant journey across Pune. Whether you need a vehicle for local city travel or longer excursions, this service prioritizes convenience, punctuality, and customer satisfaction. The vans come with ample seating, luggage space, and are equipped to provide a smooth ride even on Pune’s busy roads. Ideal for travelers seeking reliability and comfort, Urbania On Rent in Pune stands out with its affordable pricing and flexible rental packages."
    },
    {
      "name": "Urbania Hire Pune",
      "description": "Urbania Hire Pune provides flexible rental options for Urbania vans, catering to both short-term and long-term needs. Ideal for city tours, business trips, and personal use, the service focuses on reliability and convenience. With easy booking processes and transparent pricing, customers can quickly reserve vehicles that suit their travel requirements. Experienced chauffeurs ensure safe driving, and the vans are regularly serviced to maintain high standards of performance. This service is tailored for those who want hassle-free mobility solutions across Pune without compromising on comfort or quality."
    },
    {
      "name": "Urbania Rental Pune",
      "description": "Urbania Rental Pune delivers affordable and quality van rental services with modern vehicles and courteous drivers. Suitable for weddings, outstation travel, and corporate events, this service prioritizes customer satisfaction by offering timely pickups and drop-offs. The vans are spacious and air-conditioned, ensuring a comfortable journey for all passengers. Whether you are planning a group outing or need transport for an important occasion, Urbania Rental Pune combines professionalism and flexibility to meet diverse client needs. Additionally, the service provides customizable packages and competitive rates, making it accessible for various budgets."
    },
    {
      "name": "Force Urbania On Rent Pune",
      "description": "Force Urbania On Rent Pune specializes in renting Force Urbania vans with AC and Non-AC options. The service caters to diverse travel needs with well-maintained vans and experienced chauffeurs. Whether you require transportation for corporate trips, family gatherings, or long-distance travel, this rental service offers dependable vehicles that guarantee safety and comfort. The vans are inspected regularly to ensure mechanical reliability, and drivers are trained for courteous and efficient service. Customers benefit from transparent pricing, flexible booking durations, and 24/7 customer support to handle any travel emergencies."
    },
    {
      "name": "AC Urbania Pune",
      "description": "AC Urbania Pune provides air-conditioned van rentals ensuring comfort during hot weather. Perfect for corporate travel and family outings, the service offers premium vehicles and timely service. The fleet includes well-maintained Urbania vans with advanced cooling systems, ensuring a pleasant ride even during Pune’s warmer months. Drivers are professionally trained to maintain smooth driving standards and courteous customer interaction. This service is ideal for clients who prioritize comfort, cleanliness, and punctuality in their travel arrangements, whether for short commutes or longer trips across the city and outskirts."
    },
    {
      "name": "Non AC Urbania Pune",
      "description": "Non AC Urbania Pune offers budget-friendly van rental options without compromising on safety and vehicle condition. Ideal for economical travel across Pune and nearby areas, this service maintains a fleet of clean and reliable vans suited for group travel. Whether you are organizing a school trip, local sightseeing, or simple daily transportation, Non AC Urbania Pune provides value-driven packages. The drivers are trained for safe driving, and vehicles undergo routine maintenance checks to ensure dependability. This service suits customers who need spacious transport without the additional cost of air-conditioning."
    },
    {
      "name": "Urbania Hire in Hinjewadi",
      "description": "Urbania Hire in Hinjewadi focuses on serving the tech hub area with reliable and prompt van rental services tailored to corporate clients and IT professionals. The service understands the need for punctuality in the fast-paced corporate environment and ensures timely pickups for office commutes, client meetings, and corporate events. Vans are equipped with comfortable seating and sufficient space for laptops and luggage. With flexible rental plans and professional chauffeurs, Urbania Hire in Hinjewadi guarantees efficient and stress-free transportation solutions customized to the needs of Pune’s IT workforce."
    },
    {
      "name": "Urbania Hire in Baner",
      "description": "Urbania Hire in Baner provides convenient van rentals with flexible packages for residents and businesses in the Baner locality. This service supports daily commuting, family outings, and event transportation with well-maintained vans and experienced drivers. It emphasizes safety, punctuality, and customer-friendly booking options to accommodate both short and long-term rentals. With transparent pricing and attentive customer service, Urbania Hire in Baner strives to make travel hassle-free for local customers while maintaining high standards of vehicle upkeep and professionalism."
    },
    {
      "name": "Urbania Hire in Hadapsar",
      "description": "Urbania Hire in Hadapsar offers easy booking of Urbania vans, suited for personal and business travel, with professional chauffeurs and punctual service. Catering to the growing residential and commercial sectors in Hadapsar, this rental service is ideal for airport transfers, local sightseeing, and intercity travel. Vehicles are regularly sanitized and inspected to ensure safety and hygiene, making them suitable for families and groups. The team focuses on delivering a comfortable travel experience with flexible rental durations and competitive pricing."
    },
    {
      "name": "Urbania Hire in Pimpri",
      "description": "Urbania Hire in Pimpri delivers efficient and affordable van rental services, catering to industrial and residential customers in the Pimpri region. This service supports diverse transportation needs including factory employee shuttles, group tours, and event logistics. The fleet consists of sturdy and well-maintained vans driven by experienced chauffeurs familiar with the region’s traffic patterns. Urbania Hire in Pimpri prioritizes timely service, vehicle cleanliness, and customer satisfaction to provide a reliable transport option for all clients."
    },
    {
      "name": "Urbania for Corporate Pune",
      "description": "Urbania for Corporate Pune specializes in executive van rentals for business meetings, airport transfers, and corporate events, ensuring professionalism and comfort. With premium vehicles and highly trained chauffeurs, the service delivers a seamless travel experience that reflects corporate standards. Flexible booking options and customized billing solutions make it easy for companies to manage their transport needs efficiently. This service also emphasizes confidentiality and punctuality, catering to busy executives who value both time and privacy."
    },
    {
      "name": "Urbania for Wedding Pune",
      "description": "Urbania for Wedding Pune offers elegantly maintained vans for wedding parties, guest transportation, and related events, with timely service and courteous drivers. The vans can be decorated as per the occasion, adding a touch of elegance to your special day. This service ensures smooth coordination with wedding planners and event organizers to meet tight schedules and guest needs. With a focus on reliability and comfort, Urbania for Wedding Pune helps make your celebration memorable and hassle-free by providing spacious, clean, and stylish transportation."
    },
    {
      "name": "Urbania for Outstation Pune",
      "description": "Urbania for Outstation Pune provides long-distance van rentals with experienced drivers for safe and comfortable outstation travel. Whether you are planning a family vacation, corporate retreat, or group tour, this service offers well-maintained vehicles equipped to handle long journeys with ease. Drivers are trained for endurance driving and customer service, ensuring timely stops and smooth navigation. The vans have ample luggage space and comfortable seating, making extended travel across Maharashtra and neighboring states relaxing and enjoyable."
    },
    {
      "name": "Affordable Urbania Pune",
      "description": "Affordable Urbania Pune focuses on budget-friendly van rentals without compromising quality, suitable for small groups and family trips. This service offers transparent pricing, no hidden charges, and flexible rental plans to meet the diverse needs of customers. Vehicles are well-maintained to ensure safety and reliability, and drivers are professional and courteous. Ideal for school outings, local excursions, and casual group travel, Affordable Urbania Pune makes comfortable transportation accessible to all segments of the market."
    },
    {
      "name": "Luxury Urbania Van Pune",
      "description": "Luxury Urbania Van Pune offers premium vans equipped with advanced amenities for a high-end travel experience across Pune. Designed for clients who expect comfort, style, and exclusivity, this service provides vehicles with plush interiors, entertainment systems, and climate control. Whether for corporate events, VIP transport, or special occasions, Luxury Urbania Van Pune ensures a sophisticated and memorable journey. The professional chauffeurs are trained to provide discreet and attentive service, enhancing the overall travel experience."
    },
    {
      "name": "Urbania Booking Online Pune",
      "description": "Urbania Booking Online Pune enables easy and quick online reservations for Urbania vans with instant confirmation and 24/7 customer support. The platform features a user-friendly interface that allows customers to select vehicle types, rental durations, and additional services with just a few clicks. Real-time availability and GPS tracking enhance transparency and convenience. The service also offers multiple payment options, flexible cancellation policies, and dedicated support to resolve queries promptly, making Urbania Booking Online Pune the preferred choice for modern travelers."
    },
    {
      "name": "Urbania Hire near Me Pune",
      "description": "Urbania Hire near Me Pune provides localized van rental services with quick pickups and drop-offs tailored to your location in Pune. By leveraging a network of strategically located vehicles and drivers, the service ensures minimal wait times and prompt responses. Ideal for last-minute travel, daily commutes, and urgent transportation needs, Urbania Hire near Me Pune combines technology and efficiency to deliver reliable mobility solutions. Customer convenience and satisfaction are central to this service."
    },
    {
      "name": "Urbania Tour Rental Pune",
      "description": "Urbania Tour Rental Pune specializes in vans for sightseeing and tours around Pune, with knowledgeable drivers and customizable itineraries. Whether exploring historical landmarks, nature spots, or city highlights, this service offers comfortable and spacious vehicles ideal for groups and families. The drivers often act as local guides, providing insights and assistance during the trip. Urbania Tour Rental Pune is perfect for tourists and residents alike who want an organized and hassle-free touring experience with flexibility to choose destinations and schedules."
    }
  ],
  "tableData": [
    ["Urbania On Rent in Pune", "Urbania Hire Pune"],
    ["Urbania Rental Pune", "Force Urbania On Rent Pune"],
    ["AC Urbania Pune", "Non AC Urbania Pune"],
    ["Urbania Hire in Hinjewadi", "Urbania Hire in Baner"],
    ["Urbania Hire in Hadapsar", "Urbania Hire in Pimpri"],
    ["Urbania for Corporate Pune", "Urbania for Wedding Pune"],
    ["Urbania for Outstation Pune", "Affordable Urbania Pune"],
    ["Luxury Urbania Van Pune", "Urbania Booking Online Pune"],
    ["Urbania Hire near Me Pune", "Urbania Tour Rental Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Urbania On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers seamless Urbania rental services in Pune, providing comfortable and reliable rides for all your urban travel needs."
  },
  {
    "WhyChooseheading": "Well-Maintained Urbania Vehicles",
    "WhyChoosedescription": "Our Urbania cars are regularly serviced and maintained to ensure safety, cleanliness, and optimal performance."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Get competitive rental rates with clear pricing, inclusive of all taxes and fees, with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Rental Durations",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term Urbania rental plans tailored to suit your schedule and budget."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our skilled drivers prioritize your comfort and safety, ensuring a smooth and pleasant travel experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, inquiries, and travel assistance."
  },
  {
    "WhyChooseheading": "Easy Booking and Quick Delivery",
    "WhyChoosedescription": "Book your Urbania rental effortlessly online or via phone, with prompt vehicle delivery anywhere in Pune."
  },
  {
    "WhyChooseheading": "Commitment to Customer Satisfaction",
    "WhyChoosedescription": "At Amruta Travels Pvt Ltd, we strive to provide reliable, efficient, and customer-focused rental services for all your Urbania travel needs."
  }
]


























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer Urbania on rent in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides convenient and affordable Urbania rental services in Pune, perfect for both short and long-term stays.',
  },
  {
    question: 'How can I book Urbania on rent in Pune through Amruta Travels Pvt Ltd?',
    answer: 'You can book Urbania rentals easily by visiting our website, using our mobile app, or contacting our 24x7 customer support in Pune.',
  },
  {
    question: 'What types of Urbania apartments are available for rent in Pune?',
    answer: 'Amruta Travels offers a variety of Urbania apartments including 1BHK, 2BHK, and fully furnished options tailored to your needs in Pune.',
  },
  {
    question: 'Are the Urbania rental apartments in Pune fully furnished?',
    answer: 'Yes, most Urbania apartments rented through Amruta Travels come fully furnished with modern amenities for a comfortable stay.',
  },
  {
    question: 'Is there flexibility in rental duration for Urbania apartments in Pune?',
    answer: 'Absolutely, Amruta Travels offers flexible rental terms for Urbania apartments in Pune, including short-term and long-term lease options.',
  },
  {
    question: 'Are maintenance and housekeeping services included with Urbania rentals in Pune?',
    answer: 'Yes, Amruta Travels provides regular maintenance and optional housekeeping services to ensure a hassle-free stay in Urbania Pune.',
  },
  {
    question: 'What safety measures are followed in Urbania rental apartments in Pune?',
    answer: 'All Urbania apartments are equipped with modern security systems, and Amruta Travels ensures strict adherence to safety protocols in Pune.',
  },
  {
    question: 'What are the payment options for Urbania rentals in Pune?',
    answer: 'We accept multiple payment methods including UPI, credit/debit cards, net banking, and bank transfers for Urbania rentals in Pune.',
  },
  {
    question: 'Is customer support available during my Urbania rental period in Pune?',
    answer: 'Yes, Amruta Travels offers 24x7 customer support throughout your rental period in Pune to assist with any queries or issues.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Amruta Travels made renting an Urbania apartment in Pune effortless. The apartment was clean, well-maintained, and exactly as described.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Deshpande',
    feedback: 'Great service by Amruta Travels for Urbania rentals in Pune. Flexible lease terms and excellent customer support throughout my stay.',
    rating: 5,
  },
];


























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/21.jpg",
  "description": "Book Urbania On Rent in Pune with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Force Urbania vans for corporate trips, weddings, and outstation travel. Comfortable, affordable, and reliable Urbania rental service in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.87",
    "ratingCount": "15340"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/urbania-on-rent-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Urbania On Rent in Pune | Force Urbania Van Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Urbania On Rent in Pune with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury Force Urbania vans for weddings, corporate events, and outstation trips. Affordable and comfortable Urbania hire in Pune."
  />
  <meta
    name="keywords"
    content="Urbania On Rent in Pune, Urbania Hire Pune, Urbania Rental Pune, Force Urbania On Rent Pune, AC Urbania Pune, Non AC Urbania Pune, Urbania Hire in Hinjewadi, Urbania Hire in Baner, Urbania Hire in Hadapsar, Urbania Hire in Pimpri, Urbania for Corporate Pune, Urbania for Wedding Pune, Urbania for Outstation Pune, Affordable Urbania Pune, Luxury Urbania Van Pune, Urbania Booking Online Pune, Urbania Hire near Me Pune, Urbania Tour Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentinpune;